export default {
  translation: {
    navigation: {
      products: 'Produkti',
      whereToBuy: 'Kur pirkt',
    },
    hero: {
      title: 'Veidojam mirkļus ap jūsu galdu',
      description: 'Vai meklējat stilīgu un praktisku galdu visai ģimenei un viesiem? Vai varbūt vēlaties atrast minimālistisku variantu mazai virtuvei? Tad esat nonācis īstajā vietā. Mūsu sortimentā ir praktiski, moderni, skandināvu stila, industriāli un klasiski varianti, un jūs viegli atradīsiet to, kas vislabāk piestāvēs jūsu mājas dekoram vai pat kļūs par tā centrālo elementu.',
      exploreButton: 'Izpētīt kolekciju',
    },
    products: {
      title: 'Mūsu kolekcija',
      description: 'Kolekcija sastāv no galdiem, kas izgatavoti no kvalitatīviem materiāliem, piemēram, skaidu plates (MDF; MDP), masīvkoka, metāla, stikla, plastmasas, marmora un citiem materiāliem, kas garantē, ka jūs varēsiet baudīt savas mēbeles daudzus gadus. Tāpēc negaidiet un sāciet meklēt savu svarīgāko ēdamistabas mēbeli!',
      inStock: 'Noliktavā',
      preOrder: 'Priekšpasūtījums',
      viewDetails: 'Skatīt detaļas',
      currency: '€',
    },
    cta: {
      title: 'Kur pirkt',
      description: 'Mūsu galdi ir pieejami caur partneru veikalu.',
      chat: {
        title: 'Tērzējiet ar mums',
        description: 'Saņemiet tūlītējas atbildes par mūsu produktiem, cenām un pieejamību.',
        button: 'Sākt tērzēšanu',
      },
      buy: {
        title: 'Pirkt no partneriem',
        description: 'Apmeklējiet mūsu partneru veikalu, lai iegādātos preces un personīgi novērtētu kvalitāti.',
        button: 'Pirkt',
      },
    },
    footer: {
      description: 'Katrs izstrādājums stāsta amatniecības un uzticības stāstu.',
      contact: 'Sazinieties ar mums',
      rights: 'Visas tiesības aizsargātas.',
      poweredBy: 'izstrādāts ar',
    },
    product: {
      backToCollection: 'Atpakaļ uz kolekciju',
      colors: 'Pieejamās krāsas',
      features: 'Funkcijas',
      specifications: 'Specifikācijas',
      dimensions: 'Izmēri',
      material: 'Materiāls',
      weight: 'Svars',
      finish: 'Apdare',
      warranty: '24 mēnešu garantija',
      assembly: 'Nepieciešama montāža',
      delivery: 'Bezmaksas piegāde',
      returns: 'Bezmaksas atgriešana',
      buyNow: 'Pirkt tagad',
      notFound: 'Produkts nav atrasts',
      returnToCollection: 'Atgriezties pie kolekcijas',
    },
  },
};